// extracted by css-extract-rspack-plugin
export default {"note":"ProfileForm__note--G7NKP","shape":"ProfileForm__shape--mMcnT","message":"ProfileForm__message--DoxfQ","profileFormInformation":"ProfileForm__profileFormInformation--C0wQf"};